// component when custom task is selected from dropdown
import { Box, TextField, Typography, styled } from '@mui/material';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    '& fieldset': {
      padding: '12px',
      border: '1px solid var(--Accent-Moonstone-Blue, #7CAEBE)',
      color: theme.palette.primary.main,
    },
    '&:hover fieldset': {
      border: '1px solid var(--Accent-Moonstone-Blue, #7CAEBE)',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid var(--Accent-Moonstone-Blue, #7CAEBE)',
    },
  },
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    bottom: '0px',
    right: '0px',
  },
}));

interface ICustomData {
  customMessage: string;
}

interface ICustomTaskProps {
  handleCustomChange: (_event: ChangeEvent<HTMLInputElement>) => void;
  customData: ICustomData;
}

function CustomTask({ handleCustomChange, customData }: ICustomTaskProps) {
  const { t } = useTranslation();

  const maxCharacters = 30;
  return (
    <Box mt="16px" display="flex" flexDirection="column" gap="16px">
      <Box display="flex" flexDirection="column">
        <Typography variant="meta">
          {t('activity.assignActivity.customTaskMessageInput.label')}
        </Typography>
        <StyledTextField
          id="outlined-select-currency"
          name="customMessage"
          value={customData.customMessage}
          onChange={handleCustomChange}
          multiline
          rows={1}
          helperText={
            customData.customMessage.length > maxCharacters
              ? t('activity.assignActivity.customTaskDescriptionInput.helperText')
              : ''
          }
          error={customData.customMessage.length > maxCharacters}
          placeholder={t('activity.assignActivity.customTaskMessageInput.placeholder')}
        />
      </Box>
    </Box>
  );
}

export default CustomTask;
